import { BaseRouteService } from 'core/services';

class ProductRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'products/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}

	get(id, options) {
		return super.get(
			this.base + '{id}/{?embed,calculateInventory,isSpecificWarehouse,includeOnlySellerWarehouses}',
			id,
			options
		);
	}

	linkProduct(resource, sourceOfChange) {
		return super.update(this.base + 'link-product/{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	setProductActivity(resource, sourceOfChange) {
		return super.update(this.base + 'set-product-activity/{id}/?sourceOfChange={sourceOfChange}', resource, {
			sourceOfChange,
		});
	}

	create(sourceOfChange) {
		return super.create(this.base + '/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	createBatch(sourceOfChange) {
		return super.create(this.base + 'batch/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	updateProducts(sourceOfChange) {
		return super.create(this.base + 'updateProducts/?sourceOfChange={sourceOfChange}', { sourceOfChange });
	}

	update(resource, sourceOfChange) {
		return super.update(this.base + '{id}/?sourceOfChange={sourceOfChange}', resource, { sourceOfChange });
	}

	delete(resource) {
		return super.delete(this.base + '{id}', resource);
	}
}

export default ProductRouteService;
